const NEEDS_QUOTING = /[\s:/]/;

/**
 * Formats a column alias exactly as it appears in the generated SQL: quoted when it
 * contains whitespace/`:`/`/`, bare otherwise. Shared so a caller building a JOIN can
 * reference the same column name that replaceSqlAliases produces.
 */
function formatSqlAlias(alias: string): string {
  return NEEDS_QUOTING.test(alias) ? `"${alias}"` : alias;
}

export default formatSqlAlias;
